import { Button, ButtonProps } from "antd";
import { CaretLeftIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { useAntTheme } from "hooks/useAntTheme";

export const BackToButton = ({
  resource,
  ...props
}: { resource: string } & ButtonProps) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  return (
    <Button
      type="text"
      size="large"
      icon={<CaretLeftIcon />}
      style={{ padding: 0, fontSize: theme.fontSizeHeading3, fontWeight: 300 }}
      {...props}
    >
      {t("buttons.backTo", {
        resource: resource.toLowerCase(),
      })}
    </Button>
  );
};
